export const mainMenu = {
    displayMenu: {
        manager: {
            'level0':
                [
                   'home',
                    {
                        'name': 'parameter',
                        'translate': {
                            'parent': {
                                learner: 'generic.my_classes_learner',
                                default: 'navigation.groups-management'
                            },
                            'childs': {
                                'param-child-groups': {
                                    learner: 'generic.my_class',
                                    default: 'groups-management.classes'
                                },
                                'param-child-workgroups': {
                                    learner: 'generic.my_workgroups',
                                    default: 'groups-management.workgroups'
                                }
                            }
                        }
                    },
                    'onlyModels',
                    'recommendation',
                    {
                        'name': 'followed-tab',
                        'translate': {
                            'parent': {
                                learner: 'assignment.title_my_activity',
                                default: 'assignment.title'
                            }
                        }
                    },
                    // followed with tab include followed list and diary log use only in mathia for moment
                    'graph-mathia',
                    {
                        name: 'feedback',
                        class: ['menu-break'],
                    },
                    'informations-legales',
                    'site-map',
                ],
        },
        learner: {
            'level0':
                [
                   'home',
                    {
                        'name': 'parameter',
                        'translate': {
                            'parent': {
                                learner: 'generic.my_classes_learner',
                                default: 'navigation.groups-management'
                            },
                            'childs': {
                                'param-child-groups': {
                                    learner: 'generic.my_class',
                                    default: 'groups-management.classes'
                                },
                                'param-child-workgroups': {
                                    learner: 'generic.my_workgroups',
                                    default: 'groups-management.workgroups'
                                }
                            }
                        }
                    },
                    {
                        'name': 'followed-tab',
                        'translate': {
                            'parent': {
                                learner: 'assignment.title_my_activity',
                                default: 'assignment.title'
                            }
                        }
                    },
                    'myresults',
                    'access-adventure',
                    {
                        name: 'feedback',
                        class: ['menu-break'],
                    },
                    'informations-legales',
                    'site-map',
                ],
        },
        trainer: {
            'level0':
                [
                    'home',
                    {
                        'name': 'parameter',
                        'translate': {
                            'parent': {
                                learner: 'generic.my_classes_learner',
                                default: 'navigation.groups-management'
                            },
                            'childs': {
                                'param-child-groups': {
                                    learner: 'generic.my_class',
                                    default: 'groups-management.classes'
                                },
                                'param-child-workgroups': {
                                    learner: 'generic.my_workgroups',
                                    default: 'groups-management.workgroups'
                                }
                            }
                        }
                    },
                    'lessonsDeployable',
                    'recommendations',
                    'assignations_iframe',
                    'followeds',
                    'results',
                    {
                        name: 'feedback',
                        class: ['menu-break'],
                    },
                    'informations-legales',
                    'site-map',
                ],
        },
        default: {
            'level0':
                [
                    {
                        'name': 'dashboard',
                        'translate': {
                            'parent': {
                                default: 'navigation.dashboard_trainer',
                            }
                        }
                    },
                    {
                        'name': 'parameter',
                        'translate': {
                            'parent': {
                                learner: 'generic.my_classes_learner',
                                default: 'navigation.groups-management'
                            },
                            'childs': {
                                'param-child-groups': {
                                    learner: 'generic.my_class',
                                    default: 'groups-management.classes'
                                },
                                'param-child-workgroups': {
                                    learner: 'generic.my_workgroups',
                                    default: 'groups-management.workgroups'
                                }
                            }
                        }
                    },
                    'lessonsDeployable',
                    {
                        'name': 'followed-tab',
                        'translate': {
                            'parent': {
                                learner: 'assignment.title_my_activity',
                                default: 'assignment.title'
                            }
                        }
                    },
                    // followed with tab include followed list and diary log use only in mathia for moment
                    'graph-mathia',
                    {
                        name: 'feedback',
                        class: ['menu-break'],
                    },
                    'informations-legales',
                    'site-map',
                ],
        }
    }
};
